import { Link } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import { useTheme } from "../ThemeContext";

export default function NotFound() {
  const savedTheme = localStorage.getItem("theme") || "light";
  const [theme, setTheme] = useState(savedTheme);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === "light" ? "dark" : "light"));
  };

  return (
    <>
      <div className="notfound_sec h-100vh">
        <div className="container h-100">
          <div className="row g-4  h-100">
            <div className="col-12 h-100 text-center">
              <div className="not_found_logo mb-3">
                <Link className="navbar-brand found_logo me-0" to="/">
                  <img
                    src={
                      theme === "dark"
                        ? "/assets/images/logo/dark-logo.svg"
                        : "/assets/images/logo/logo.svg"
                    }
                    alt="Logo"
                  />
                </Link>
              </div>
              <h2 class="notfound_title mb-3">404</h2>
              <h1 className="notfound_title2 mb-3">Oooop! Page not found</h1>
              <p className="fs-5 mb-4 notfound_txt">
                The page you’re looking for doesn’t exist or may have been
                moved.
                <br className="d-none d-lg-block" />
                Let’s get you back to the platform.
              </p>

              <Link to="/" className="mt-3">
                <button
                  class="button theme_btn mt-4 mt-lg-0 back_btn"
                  type="submit"
                >
                  Back to Home
                  <i className="bi bi-caret-right-fill ms-1"></i>
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
